import dayjs from "dayjs";
export const usePassProgress = (startDate, endDate)=>{
    const totalDays = dayjs(endDate).diff(startDate, "day");
    if (totalDays <= 0) return 0;
    const elapsed = dayjs().diff(startDate, "day");
    return Math.min(100, Math.max(0, elapsed / totalDays * 100));
};
